<ng-container *ngIf="isDesktop; else isMobile">
  <app-login-web
    [(loginObjform)]="loginObjform"
    [base64Image]="base64Image"
    [loading]="loading"
    (loginFormVal)="loginFormVal($event)"
    (validateFormBtnClicked)="validateForm()"
    (reloadCaptchaImageClicked)="reloadCaptchaImage()"
  >
  </app-login-web>
</ng-container>
<ng-template #isMobile>
  <app-login-mob
    [(loginObjform)]="loginObjform"
    [base64Image]="base64Image"
    [loading]="loading"
    (loginFormVal)="loginFormVal($event)"
    (validateFormBtnClicked)="validateForm()"
    (reloadCaptchaImageClicked)="reloadCaptchaImage()"
  >
  </app-login-mob>
</ng-template>
<div class="modal fade" id="showBanner" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="text-right">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <a [href]="redirectionSrc" target="_blank">
          <img [src]="bannerSrc" style="width: 100%;height: 100%;">
        </a>
      </div>
    </div>
  </div>
</div>